import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FormattedMessage } from 'react-intl';
import { Pagination, Scrollbar, A11y } from 'swiper/modules';

import Item from './Item';
import Box from '../../../components/layout/Box';
import Text from '../../../components/Text';

import 'swiper/css';
import 'swiper/css/pagination';
import './styles.css';

const PopularProducts = ({ items }) => {
  const formatted = items.length % 2 !== 0 ? items.slice(0, -1) : items;

  return (
    <Box className="flex-column mb-4">
      <Text variant="sectionTitle">
        <FormattedMessage defaultMessage="Populära böcker" />
      </Text>

      <Text variant="sectionSubtitle" className="mb-3 mt-1">
        <FormattedMessage defaultMessage="Här är några av de mest populära böckerna just nu." />
      </Text>

      <Box className="flex-grow-1 flex-shrink-1">
        <Swiper
          modules={[Pagination, Scrollbar, A11y]}
          pagination={true}
          scrollbar={{ draggable: true }}
          spaceBetween={10}
          slidesPerView="auto"
          style={{ overflow: 'hidden' }}
          breakpoints={{
            480: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            640: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
          }}
        >
          {formatted.length &&
            formatted.map((item) => {
              return (
                <SwiperSlide key={item.id}>
                  <Item
                    key={item.id}
                    id={item.id}
                    title={item.title}
                    subtitle={item.subtitle}
                    author={item.author}
                    thumbnail={item.thumbnail}
                  />
                </SwiperSlide>
              );
            })}
        </Swiper>
      </Box>
    </Box>
  );
};

export default PopularProducts;
